import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "react-phone-input-2/lib/bootstrap.css";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Button from "components/CustomButtons/Button.js";
import { RiMapPinUserFill } from "react-icons/ri";

import SweetAlert from "react-bootstrap-sweetalert";
import { localApi, credentials } from "utils/headApi";

import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import basicsCheck from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";
import { Redirect } from "react-router-dom";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(profilePageStyle);
const useStyle = makeStyles(basicsCheck);
const useStyleAlert = makeStyles(style);
const useStyl = makeStyles(aboutUsStyle);

export default function AccountDelete({ ...rest }) {
  const [clientid, setClientid] = React.useState("");
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [confirmDelete, setConfirmDelete] = React.useState(false);

  const classes = useStyles();
  const classeAlert = useStyleAlert();
  const classeTitel = useStyl();

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  useEffect(() => {
    const fetchRegClientData = async () => {
      try {
        const response = await fetch(localApi + `/clientGroup/allList`, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });

        const json = await response.json();

        const cList = json.ClientList.filter((f) => f.regId === userObj.id)[0];

        setClientid(cList);
      } catch (error) {
        console.log("error", error);
      }
    };

    if (userObj) {
      fetchRegClientData();
    }
  }, []);

  const Submit = async () => {
    try {
      if (!clientid || !clientid.id) {
        alertTypeOps("danger");
        alertMsgOps("Client data not found. Please try again.");
        setSubmitted(true);
        return;
      }

      const list =
        localApi +
        `/cart/byAdminAndClientId/${userObj.admin.id}/${clientid.id}`;

      const result = await fetch(list, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });

      const cartData = await result.json();

      const hasCartData = Array.isArray(cartData)
        ? cartData.length > 0
        : Array.isArray(cartData.CartList)
        ? cartData.CartList.length > 0
        : Array.isArray(cartData.cartList)
        ? cartData.cartList.length > 0
        : false;

      if (hasCartData) {
        alertTypeOps("danger");
        alertMsgOps(
          "Your account cannot be deleted because it contains transaction records. As per applicable Government regulations and record retention requirements, this account cannot be permanently deleted at this time.",
        );
        setSubmitted(true);
        return;
      }

      setConfirmDelete(true);
    } catch (error) {
      console.log(error);
      alertTypeOps("danger");
      alertMsgOps("Something went wrong.");
      setSubmitted(true);
    }
  };

  const deleteAccount = async () => {
    setConfirmDelete(false);
    // console.log(userObj.id);

    try {
      const deleteResponse = await fetch(
        localApi + `/register/delete/byId/${userObj.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      const data = await deleteResponse.json();
      //   console.log(data);

      if (data.message === "Deleted Successfully !!!") {
        alertTypeOps("success");
        alertMsgOps("Account deleted successfully.");
        setSubmitted(true);
      } else {
        alertTypeOps("danger");
        alertMsgOps("Account delete failed.");
        setSubmitted(true);
      }
    } catch (error) {
      console.log(error);
      alertTypeOps("danger");
      alertMsgOps("Something went wrong.");
      setSubmitted(true);
    }
  };

  const hideAlert = () => {
    setSubmitted(false);

    if (alertType === "success") {
      window.location.href = "/";
    } else {
      window.location.reload(false);
    }
  };

  return (
    <div>
      {activeSession ? (
        <>
          <Helmet>
            <title>Account Delete</title>
          </Helmet>

          <InshaHeader
            // color="transparent"
            brand="Home"
            links={<InshaHeaderLink dropdownHoverColor="dark" />}
            fixed
            color="dark"
            // changeColorOnScroll={{
            //   height: 200,
            //   color: "dark",
            // }}
            {...rest}
          />

          <Parallax
            image={require("assets/img/examples/city.png").default}
            // filter="dark"
            className={classes.parallax}
          >
            <div className={classeTitel.container}>
              <GridContainer justify="center">
                <GridItem
                  md={8}
                  sm={8}
                  className={classNames(
                    classeTitel.mlAuto,
                    classeTitel.mrAuto,
                    classeTitel.textCenter,
                  )}
                >
                  <h1 className={classeTitel.title}>Account Delete</h1>
                </GridItem>
              </GridContainer>
            </div>
          </Parallax>

          <div className={classNames(classes.main, classes.mainRaised)}>
            <div className={classes.container}>
              {confirmDelete ? (
                <SweetAlert
                  warning
                  showCancel
                  confirmBtnText="Yes, Delete"
                  cancelBtnText="Cancel"
                  confirmBtnCssClass={
                    classeAlert.button + " " + classeAlert.danger
                  }
                  cancelBtnCssClass={
                    classeAlert.button + " " + classeAlert.default
                  }
                  title="Delete Account?"
                  onConfirm={deleteAccount}
                  onCancel={() => setConfirmDelete(false)}
                >
                  Are you sure you want to permanently delete your account?
                  <br />
                  This action cannot be undone.
                </SweetAlert>
              ) : null}

              {submitted ? (
                <SweetAlert
                  type={alertType}
                  style={{ display: "block", marginTop: "100px" }}
                  title={alertMsg}
                  onConfirm={() => hideAlert()}
                  confirmBtnCssClass={
                    classeAlert.button + " " + classeAlert.success
                  }
                />
              ) : null}

              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>
                  <div className={classes.profile}>
                    <h3 className={classes.title}>
                      <RiMapPinUserFill color="#e91e63" size={35} />
                      Delete Account Permanently
                    </h3>
                  </div>
                </GridItem>
              </GridContainer>

              <GridContainer justify="center">
                <Button color="rose" onClick={Submit}>
                  Delete
                </Button>
              </GridContainer>
              <GridContainer justify="center" style={{ marginTop: 30 }}>
                <GridItem xs={12} sm={10} md={8}>
                  <div
                    style={{
                      background: "#fff8e1",
                      border: "1px solid #ffe082",
                      borderRadius: 8,
                      padding: "18px 20px",
                      textAlign: "left",
                      color: "#555",
                      lineHeight: "28px",
                      marginBottom: 40,
                    }}
                  >
                    <h4
                      style={{
                        marginTop: 0,
                        color: "#d32f2f",
                        fontWeight: 600,
                      }}
                    >
                      Important Notes
                    </h4>

                    <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                      <li>
                        Account deletion is permanent and cannot be undone once
                        completed.
                      </li>

                      <li>
                        Your personal profile information will be permanently
                        removed from our active systems.
                      </li>

                      <li>
                        If your account contains transaction records, orders,
                        invoices, payment history, or other business records, it
                        may not be eligible for immediate deletion.
                      </li>

                      <li>
                        Certain records are retained as required under
                        applicable Government regulations, tax laws, and legal
                        record retention requirements.
                      </li>

                      <li>
                        After successful deletion, you will be logged out of all
                        devices and will need to register again to use the
                        application.
                      </li>

                      <li>
                        If your account cannot be deleted, please contact
                        customer support for further assistance.
                        support@inshabangles.com
                      </li>
                    </ul>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
          </div>

          <br />
          <br />
          <Footer />
        </>
      ) : (
        <Redirect to="/" />
      )}
    </div>
  );
}
